export default "__VITE_ASSET__BbwnJw8D__"